module.exports = __webpack_public_path__ + "static/img/left-num-row-6.db5b6386.png";